import { render, staticRenderFns } from "./SingleLayerInfos.vue?vue&type=template&id=5a90013e&scoped=true"
import script from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerInfos.vue?vue&type=style&index=0&id=5a90013e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90013e",
  null
  
)

export default component.exports